import React, { forwardRef } from 'react'

import * as Styled from './styles'

interface Props {
  level: 1 | 2 | 3 | 4 | 5 | 6
  className?: string
  children: React.ReactNode
}

const Heading = forwardRef<HTMLHeadingElement, Props>(function Heading({ level, className, children }, ref) {
  switch (level) {
    case 1:
      return (
        <Styled.h1 ref={ref} className={className}>
          {children}
        </Styled.h1>
      )
    case 2:
      return (
        <Styled.h2 ref={ref} className={className}>
          {children}
        </Styled.h2>
      )
    case 3:
      return (
        <Styled.h3 ref={ref} className={className}>
          {children}
        </Styled.h3>
      )
    case 4:
      return (
        <Styled.h4 ref={ref} className={className}>
          {children}
        </Styled.h4>
      )
    case 5:
      return (
        <Styled.h5 ref={ref} className={className}>
          {children}
        </Styled.h5>
      )
    case 6:
      return (
        <Styled.h6 ref={ref} className={className}>
          {children}
        </Styled.h6>
      )
    default:
      return null
  }
})

export default Heading
